export const nevadaSpecific = (nevadaSpecificText, nonNevadaText) => {
  return dynamicValues.tenantId === 'nevada' && !dynamicValues.subTenantId
    ? nevadaSpecificText
    : nonNevadaText
}
